/* eslint-disable camelcase */
import { handleActions } from 'redux-actions';
import {
  appContainerSettingFetchInitialized,
  appContainerSettingFetchSucceeded,
  appContainerSettingFetchFailed,
  appContainerSettingUpdateSucceeded,
} from '../ContainerSettings';

export interface ISpaTrackingValue {
  is_enabled?: boolean
}

export interface ISpaTrackingAttributes {
  is_custom?: boolean
  value: ISpaTrackingValue
}

export interface IAppSpaTrackingSettingData {
  id: string
  type: string
  attributes: ISpaTrackingAttributes
}

export interface IAppSpaTrackingResponse {
  data?: IAppSpaTrackingSettingData
}

export interface ISpaTrackingState {
  isLoading: boolean
  failed: boolean
  value?: ISpaTrackingValue | null
}

const initialState: ISpaTrackingState = {
  isLoading: true,
  failed: false,
  value: null,
};

export default handleActions<ISpaTrackingState, IAppSpaTrackingResponse>({
  [appContainerSettingFetchInitialized('spa_tracking').toString()]: () => initialState,
  [appContainerSettingFetchSucceeded('spa_tracking').toString()]: (
    state,
    { payload },
  ) => ({
    ...state,
    isLoading: false,
    value: {
      ...state.value,
      ...payload.data!.attributes.value,
    },
  }),
  [appContainerSettingFetchFailed('spa_tracking').toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
  }),
  [appContainerSettingUpdateSucceeded('spa_tracking').toString()]: (
    state,
    { payload },
  ) => ({
    ...state,
    value: {
      ...state.value,
      ...payload.data!.attributes.value,
    },
  }),
}, initialState);
